//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <svg
    width="100px"
    height="100px"
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>desktop icon</title>
    <g
      id="desktop-icon"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="laptop-2"
        transform="translate(11.000000, 18.000000)"
        fill-rule="nonzero"
      >
        <g id="Group">
          <path
            d="M78.9962969,57.3066377 C78.9955254,57.2950142 78.9956797,57.2835456 78.9945996,57.2719221 C78.9904336,57.2258929 78.9837988,57.1807936 78.9743867,57.1366242 C78.9734609,57.1322847 78.9720723,57.1279453 78.9709922,57.1236058 C78.9618887,57.0830009 78.950625,57.0433259 78.9373555,57.0045808 C78.9338066,56.9941971 78.9299492,56.9841234 78.9260918,56.9738947 C78.9131309,56.9387141 78.8984727,56.9044634 78.8822715,56.8711426 C78.8794941,56.8652534 78.8776426,56.8592091 78.8747109,56.8533199 L72.6855547,44.5915757 L72.6855547,2.25016133 C72.6855547,1.00938775 71.6806191,-2.48689958e-14 70.4453184,-2.48689958e-14 L8.55437305,-2.48689958e-14 C7.31907227,-2.48689958e-14 6.31413672,1.00938775 6.31413672,2.25016133 L6.31413672,44.5912657 L0.125134766,56.8531649 C0.122203125,56.8590542 0.120351562,56.8650984 0.117574219,56.8709877 C0.101373047,56.9043085 0.0868691406,56.9385591 0.0737539062,56.9735847 C0.0698964844,56.9838134 0.0660390625,56.9940421 0.0624902344,57.0044258 C0.049375,57.0433259 0.0379570312,57.0831559 0.0288535156,57.1237608 C0.0279277344,57.1279453 0.0265390625,57.1321297 0.0256132813,57.1363142 C0.0162011719,57.1806386 0.00956640625,57.2257379 0.00540039063,57.2717671 C0.0043203125,57.2832357 0.0043203125,57.2948592 0.003703125,57.3063278 C0.00216015625,57.3305047 0,57.3543717 0,57.3788586 L0,60.3275169 C0,61.8012261 1.19348633,63 2.66069531,63 L76.3393047,63 C77.8065137,63 79,61.8012261 79,60.3275169 L79,57.3788586 C79,57.3543717 78.9978398,57.3305047 78.9962969,57.3066377 Z M8.62874414,2.3250169 L70.3712559,2.3250169 L70.3712559,43.7069472 L8.62874414,43.7069472 L8.62874414,2.3250169 Z M8.18220898,46.0314991 L70.8176367,46.0314991 L75.9585,56.2163502 L50.5334609,56.2163502 L49.2572715,51.5686411 C48.9974355,50.6224854 48.1336816,49.9616487 47.1565195,49.9616487 L31.8431719,49.9616487 C30.8660098,49.9616487 30.0021016,50.6224854 29.7424199,51.5684861 L28.4662305,56.2163502 L3.0413457,56.2163502 L8.18220898,46.0314991 Z M48.1326016,56.2165052 L30.8673984,56.2165052 L31.9463965,52.2865106 L47.0536035,52.2865106 L48.1326016,56.2165052 Z M76.6855469,60.3273619 C76.6855469,60.5190728 76.5301699,60.6751381 76.3393047,60.6751381 L2.66069531,60.6751381 C2.46983008,60.6751381 2.31445312,60.5190728 2.31445312,60.3273619 L2.31445312,58.5410571 L76.6855469,58.5410571 L76.6855469,60.3273619 Z"
            id="Shape"
            stroke="#5D5D5D"
            fill="#5D5D5D"
          ></path>
          <path
            d="M19.2403649,10 L60.2379321,10 C61.618644,10 62.7379321,11.1192881 62.7379321,12.5 L62.7379321,34.5185547 C62.7379321,35.8992666 61.618644,37.0185547 60.2379321,37.0185547 L19.2403649,37.0185547 C17.859653,37.0185547 16.7403649,35.8992666 16.7403649,34.5185547 L16.7403649,12.5 C16.7403649,11.1192881 17.859653,10 19.2403649,10 Z"
            id="Rectangle"
            :style="{ fill: store.state.Style.themeColor }"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
